import { helpers } from 'vuelidate/lib/validators';

export default function dateValidator(value: string) {
  if (!helpers.req(value)) {
    return true;
  }
  const regEx = /^\d{4}-\d{2}-\d{2}$/;
  return value.match(regEx) != null;
}
